import { useTranslation } from 'react-i18next';

import { AlertDialog, Button } from '~/components';

type Props = {
  loading?: boolean;
  onConfirm: () => void;
};

export const ConfirmDeleteInvoiceTemplateDialog = ({ loading, onConfirm }: Props) => {
  const { t } = useTranslation(['invoiceTemplates']);

  return (
    <AlertDialog.Body status="danger">
      <AlertDialog.Title>{t('invoiceTemplates:deleteModal.title')}</AlertDialog.Title>

      <AlertDialog.Description>{t('invoiceTemplates:deleteModal.description')}</AlertDialog.Description>

      <AlertDialog.Actions>
        <Button emphasis="status" icon="Trash" loading={loading} onClick={onConfirm}>
          {t('invoiceTemplates:deleteModal.submit')}
        </Button>
      </AlertDialog.Actions>
    </AlertDialog.Body>
  );
};
